var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rabbey-table3',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"ObuyInside",staticStyle:{"width":"100%"},attrs:{"data":_vm.items,"border":true,"fit":true,"stripe":true,"lazy":true,"columns":_vm.columns,"max-height":"600"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }